import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions, TrelloSuspenseQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const TemplatesStoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TemplatesStory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"count"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"traceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}},{"kind":"Argument","name":{"kind":"Name","value":"count"},"value":{"kind":"Variable","name":{"kind":"Name","value":"count"}}},{"kind":"Argument","name":{"kind":"Name","value":"traceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"traceId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"desc"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"plugins"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"EnumValue","value":"enabled"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"overview"}}]}},{"kind":"Field","name":{"kind":"Name","value":"moderatedState"}}]}},{"kind":"Field","name":{"kind":"Name","value":"prefs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"background"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundImage"}},{"kind":"Field","name":{"kind":"Name","value":"isTemplate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"related"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"count"},"value":{"kind":"Variable","name":{"kind":"Name","value":"count"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idOrganization"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"prefs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundImage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shortLink"}},{"kind":"Field","name":{"kind":"Name","value":"templateGallery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatarShape"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"blurb"}},{"kind":"Field","name":{"kind":"Name","value":"byline"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"featured"}},{"kind":"Field","name":{"kind":"Name","value":"precedence"}},{"kind":"Field","name":{"kind":"Name","value":"stats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"copyCount"}},{"kind":"Field","name":{"kind":"Name","value":"viewCount"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shortUrl"}},{"kind":"Field","name":{"kind":"Name","value":"templateGallery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatarShape"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"byline"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"stats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"copyCount"}},{"kind":"Field","name":{"kind":"Name","value":"viewCount"}}]}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"TemplatesStory","document":TemplatesStoryDocument}} as const;
export type TemplatesStoryQueryVariables = Types.Exact<{
  boardId: Types.Scalars['ID']['input'];
  count?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  traceId?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type TemplatesStoryQuery = (
  { __typename: 'Query' }
  & { board?: Types.Maybe<(
    { __typename: 'Board' }
    & Pick<Types.Board, 'id' | 'desc' | 'name' | 'shortUrl'>
    & { plugins: Array<(
      { __typename: 'Plugin' }
      & Pick<Types.Plugin, 'id' | 'moderatedState'>
      & { icon: (
        { __typename: 'Plugin_Icon' }
        & Pick<Types.Plugin_Icon, 'url'>
      ), listing?: Types.Maybe<(
        { __typename: 'Plugin_Listing' }
        & Pick<Types.Plugin_Listing, 'description' | 'name' | 'overview'>
      )> }
    )>, prefs?: Types.Maybe<(
      { __typename: 'Board_Prefs' }
      & Pick<Types.Board_Prefs, 'background' | 'backgroundColor' | 'backgroundImage' | 'isTemplate'>
    )>, related: Array<(
      { __typename: 'Board' }
      & Pick<Types.Board, 'id' | 'idOrganization' | 'name' | 'shortLink'>
      & { prefs?: Types.Maybe<(
        { __typename: 'Board_Prefs' }
        & Pick<Types.Board_Prefs, 'backgroundColor' | 'backgroundImage'>
      )>, templateGallery?: Types.Maybe<(
        { __typename: 'TemplateGallery' }
        & Pick<Types.TemplateGallery, 'avatarShape' | 'avatarUrl' | 'blurb' | 'byline' | 'category' | 'featured' | 'precedence'>
        & { stats: (
          { __typename: 'Board_Stats' }
          & Pick<Types.Board_Stats, 'copyCount' | 'viewCount'>
        ) }
      )> }
    )>, templateGallery?: Types.Maybe<(
      { __typename: 'TemplateGallery' }
      & Pick<Types.TemplateGallery, 'avatarShape' | 'avatarUrl' | 'byline' | 'category'>
      & { stats: (
        { __typename: 'Board_Stats' }
        & Pick<Types.Board_Stats, 'copyCount' | 'viewCount'>
      ) }
    )> }
  )> }
);

/**
 * __useTemplatesStoryQuery__
 *
 * To run a query within a React component, call `useTemplatesStoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplatesStoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplatesStoryQuery({
 *   variables: {
 *      boardId: // value for 'boardId'
 *      count: // value for 'count'
 *      traceId: // value for 'traceId'
 *   },
 * });
 */
export function useTemplatesStoryQuery(
  baseOptions: TrelloQueryHookOptions<
    TemplatesStoryQuery,
    TemplatesStoryQueryVariables
  > &
    (
      | { variables: TemplatesStoryQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: TemplatesStoryDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    TemplatesStoryQuery,
    TemplatesStoryQueryVariables
  >(TemplatesStoryDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useTemplatesStoryLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    TemplatesStoryQuery,
    TemplatesStoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TemplatesStoryQuery, TemplatesStoryQueryVariables>(
    TemplatesStoryDocument,
    options,
  );
}
export function useTemplatesStorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | TrelloSuspenseQueryHookOptions<
        TemplatesStoryQuery,
        TemplatesStoryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TemplatesStoryQuery,
    TemplatesStoryQueryVariables
  >(TemplatesStoryDocument, options);
}
export type TemplatesStoryQueryHookResult = ReturnType<
  typeof useTemplatesStoryQuery
>;
export type TemplatesStoryLazyQueryHookResult = ReturnType<
  typeof useTemplatesStoryLazyQuery
>;
export type TemplatesStorySuspenseQueryHookResult = ReturnType<
  typeof useTemplatesStorySuspenseQuery
>;
export type TemplatesStoryQueryResult = Apollo.QueryResult<
  TemplatesStoryQuery,
  TemplatesStoryQueryVariables
>;
